export const loadingProcess = async function (store, type, callback) {
  if (store.loadingProcess[type] === true && callback === "undefined") {
    return;
  }

  store.loadingProcess[type] = true;

  try {
    await callback();
  } catch (e) {
    if (e?.code === "ERR_BAD_REQUEST" && e?.response.status === 401) {
      store.loadingProcess[type] = false;

      return;
    } else {
      console.error("error", e);
      //alert("Произошла ошибочка, подробности в консоли");
    }
  }

  store.loadingProcess[type] = false;
};
